import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, UniqueEntityID } from '@digibricks/core';
import { Assignment } from './assignment';
import { AssignmentDisplayStatusV2 } from '../assignment-display-status-v2';
import { UnixTimestamp } from '@module/form';
export var ExaminationAssignment = /*#__PURE__*/function (_Assignment) {
  _inherits(ExaminationAssignment, _Assignment);

  var _super = _createSuper(ExaminationAssignment);

  function ExaminationAssignment() {
    _classCallCheck(this, ExaminationAssignment);

    return _super.apply(this, arguments);
  }

  _createClass(ExaminationAssignment, [{
    key: "publishScoreInformation",
    get: function get() {
      return this.props.publishScoreInformation;
    }
  }, {
    key: "securityOptions",
    get: function get() {
      return this.props.securityOptions;
    }
  }, {
    key: "termsAndConditions",
    get: function get() {
      return this.props.termsAndConditions;
    }
  }, {
    key: "maximumFoulsAllowed",
    get: function get() {
      return this.props.maximumFoulsAllowed;
    }
  }, {
    key: "scoreVisibilityType",
    get: function get() {
      return this.props.scoreVisibilityType;
    }
  }, {
    key: "hasSecurityOptions",
    value: function hasSecurityOptions() {
      return this.props.securityOptions.length > 0;
    }
  }, {
    key: "hasPublished",
    value: function hasPublished() {
      return AssignmentDisplayStatusV2.isCompleted(this.displayStatus.value) && this.props.publishScoreInformation != null;
    }
  }, {
    key: "isScoreViewable",
    value: function isScoreViewable() {
      var _this$scoreVisibility;

      if ((_this$scoreVisibility = this.scoreVisibilityType) !== null && _this$scoreVisibility !== void 0 && _this$scoreVisibility.isImmediateView()) {
        return true;
      }

      var publishScoreInformation = this.publishScoreInformation;

      if (!publishScoreInformation) {
        return false;
      }

      var now = UnixTimestamp.now();
      return publishScoreInformation.startTime <= now && publishScoreInformation.endTime >= now;
    }
  }, {
    key: "shouldStartAssignment",
    value: function shouldStartAssignment() {
      if (this.isEnded()) {
        return false;
      }

      if (!this.hasPublished()) {
        return true;
      }

      var info = this.publishScoreInformation;

      if (!info) {
        return true;
      }

      var now = UnixTimestamp.now();
      var isOutsidePublishScoreWindow = info.startTime > now || info.endTime < now;
      return !isOutsidePublishScoreWindow;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var validatedBasePropsOrError = _get(_getPrototypeOf(ExaminationAssignment), "validateBaseProps", this).call(this, props);

      if (validatedBasePropsOrError.isFailure) {
        return Result.fail(validatedBasePropsOrError.error);
      }

      var guardCollection = [{
        argument: props.securityOptions,
        argumentName: 'Security Option'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok(new ExaminationAssignment(props, new UniqueEntityID(props.id)));
    }
  }]);

  return ExaminationAssignment;
}(Assignment);